import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { AxiosResponse } from 'axios'

import { PATH } from '../../constants/global'
import { useAPI } from '..'
import { UseActionDetails } from './useActionDetails.type'


export default function (): UseActionDetails {
    const request = useAPI()
    // When this is changed, a refetch will be triggered
    const [actionInput, setActionInput] = useState(null)

    const {
        data,
        refetch,
        isLoading: actionDetailsIsLoading,
        isRefetching: actionDetailsIsRefetching,
    } = useQuery(
        'action-details',
        (): Promise<AxiosResponse> => 
            getActionDetails({...actionInput}),
        {enabled: !!actionInput}
    )

    useEffect(() => {
        if (actionInput) {
            refetch()
        }
    }, [actionInput])

    async function getActionDetails(options: {}) {
        try {
            return await request.post(PATH.ITEM_ACTION.DETAILS, options)
        } catch (error) {
            console.log(error)
        }
    }

    return {
        actionDetails: data?.data || null,
        actionDetailsIsLoading,
        actionDetailsIsRefetching,
        setActionInput,
    }
}